import { useAppearance } from '../../hooks/useAppearance';
import { useConnectWithWallet } from '../../hooks/useConnectWithWallet';
import useLocales from '../../hooks/useLocales';
import { useRouter } from '../../hooks/useRouter';
import { useWalletProps } from '../../hooks/useWalletsProps';
import { RoutePath } from '../../pages';
import { isFirstRegisterPasskey, setFirstRegisterPasskey } from '../../utils';
import Button from '../button';

const PasskeyButtons = () => {
  const { navigate } = useRouter();
  const locales = useLocales();
  const { appearance } = useAppearance();
  const connectWallet = useConnectWithWallet();
  const wallet = useWalletProps('passkeySmartWallet');

  const login = () => {
    navigate(RoutePath.LoginPasskey);
  };

  if (appearance.collapsePasskeyButton) {
    return (
      <Button style={{ marginTop: 16 }} onClick={login}>
        {locales.continueWithSmartWalletPasskey}
      </Button>
    );
  }

  return (
    <div>
      <Button
        style={{ marginTop: 16 }}
        onClick={() => {
          if (isFirstRegisterPasskey()) {
            navigate(RoutePath.PasskeySetup);
            setFirstRegisterPasskey();
          } else if (wallet) {
            connectWallet(wallet, {
              passkeyParams: {
                isRegistering: true,
              },
            });
          }
        }}
      >
        {locales.createNewPasskey}
      </Button>
      <Button
        style={{
          marginTop: 16,
        }}
        color='secondary'
        onClick={() => {
          connectWallet(wallet!, {
            passkeyParams: {
              isRegistering: false,
            },
          });
        }}
      >
        {locales.loginWithPasskey}
      </Button>
    </div>
  );
};

export default PasskeyButtons;
